import React, { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent } from "./ui/dialog";
import InitiativeSheet, { InitiativeTile } from "./InitiativeSheet";
import { trackInitiative } from "../lib/initiativeTrack";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Home app cliente: tile delle iniziative pubblicate → scheda completa in dialog
export default function InitiativesHome({ onCta }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { axios.get(`${API}/public/initiatives?where=home`).then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="space-y-2" data-testid="portal-initiatives">
      <div className="text-xs uppercase tracking-widest text-zinc-500 font-semibold">Iniziative in corso</div>
      {items.map((d) => <InitiativeTile key={d.id} d={d} onClick={() => { setOpen(d); trackInitiative(d.slug, "home_open", "home"); }} />)}
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-xl p-0 bg-transparent border-0 shadow-none max-h-[92vh] overflow-y-auto [&>button]:bg-black/50 [&>button]:text-white [&>button]:rounded-full [&>button]:p-1.5 [&>button]:opacity-100 [&>button]:right-3 [&>button]:top-3" data-testid="portal-initiative-dialog"><InitiativeSheet d={open} onCta={onCta ? () => { trackInitiative(open?.slug, "cta", "home"); setOpen(null); onCta(); } : undefined} /></DialogContent>
      </Dialog>
    </div>
  );
}
